import { Section, cn, linkClasses, usePageTitle, useTranslate } from '@athena/ui'
import { Link, useParams } from '@tanstack/react-router'

/**
 * An address inside the administration that matches no screen.
 *
 * Rendered by the language route, so it sits inside the admin layout — its
 * navigation and its `main` — with its own heading and title, rather than the
 * router's bare English "Not Found". The same sentence the product uses, and a
 * way back to the accounts, which is where the administration starts.
 */
export function AdminNotFound() {
  const t = useTranslate()
  const { language } = useParams({ from: '/$language' })
  usePageTitle(t('notFound.title'))

  return (
    <Section id="not-found" level={1} title={t('notFound.title')}>
      <Link
        to="/$language"
        params={{ language }}
        className={cn(linkClasses({ size: 'md', layout: 'standalone' }), 'self-start')}
      >
        {t('admin.notFoundBack')}
      </Link>
    </Section>
  )
}
